export function lineasReglas(texto) {
  return String(texto || '')
    .split(/\n+/)
    .map((s) => s.trim())
    .filter(Boolean);
}

export function aplicarEdicionReglaFija(reglas, idx, texto) {
  const lista = Array.isArray(reglas) ? reglas : [];
  const linea = String(texto || '').trim();
  if (idx < 0 || idx >= lista.length) {
    return { reglas: lista, error: 'Regla no encontrada' };
  }
  if (!linea) {
    return { reglas: lista, error: 'La regla no puede estar vacía' };
  }
  if (linea === lista[idx]) {
    return { reglas: lista, sinCambios: true };
  }
  const duplicada = lista.some((r, i) => i !== idx && r.toLowerCase() === linea.toLowerCase());
  if (duplicada) {
    return { reglas: lista, error: 'Esa regla ya existe' };
  }
  return { reglas: lista.map((r, i) => (i === idx ? linea : r)) };
}
